import { Subject } from 'rxjs';

export class VrsChatEventBus {
  static readonly $sendMessage = new Subject<Uint8Array>();
  static readonly $receiveMessage = new Subject<string>();
  static readonly $closeDataChannel = new Subject<void>();
  static readonly $clearMessage = new Subject<void>();
  static readonly $sendSignMailMessage = new Subject<string>();
}
